import { api } from "@/lib/api";

const CHUNK = 5 * 1024 * 1024; // 5MB

export async function exportProject(pid) {
  const res = await api.get(`/transfer/projects/${pid}/export`, { responseType: "blob" });
  let name = "project.reelpack.zip";
  const cd = res.headers?.["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  if (m) name = m[1];
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function importProject(file, onProgress) {
  const { data: init } = await api.post("/transfer/import/init");
  const uploadId = init.upload_id;
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK, (i + 1) * CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("chunk", blob, "chunk");
    await api.post("/transfer/import/chunk", fd);
    onProgress && onProgress(Math.round(((i + 1) / total) * 100));
  }
  const fd = new FormData();
  fd.append("upload_id", uploadId);
  const { data } = await api.post("/transfer/import/finalize", fd);
  return data;
}
